"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FToggleService = void 0;
const domain_1 = require("../../../domain");
const mappers_1 = require("../mappers");
const queries_1 = require("../queries");
class FToggleService {
    constructor(apolloClient) {
        this.apolloClient = apolloClient;
    }
    getToggleToken(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const toggleTokenMapper = new mappers_1.ToggleTokenMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: queries_1.GET_TOGGLE_TOKEN,
                    variables,
                });
                return Promise.resolve(toggleTokenMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.ToggleTokenServiceErrors.CheckToggleTokenAvailabilityRequestError("GET_TOGGLE_TOKEN", error));
            }
        });
    }
}
exports.FToggleService = FToggleService;
